const INITIAL_STATE = {
  data: {},
  renderCount: 0,
}

const initialCleaning = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_ZIP_CODES_SUCCESSFULLY':
    return { ...INITIAL_STATE, ...state, zipCodes: action.data }
  case 'GET_ZIP_CODES_FAILED':
    return { ...INITIAL_STATE, ...state, errors: action.data }
  case 'GET_ALL_INITIAL_CLEANING_DATA_SUCESSFULLY':
    return { ...INITIAL_STATE, ...state, initial_cleaning_data: action.data }
  case 'GET_ALL_INITIAL_CLEANING_DATA_FAILED':
    return { ...INITIAL_STATE, ...state, errors: action.data }
  case 'SAVE_AREA_SUCESSFULLY':
    return { ...INITIAL_STATE, ...state, initial_cleaning_data: {...state.initial_cleaning_data, results: action.data}, renderCount: state.renderCount + 1 }
  case 'SAVE_AREA_FAILED':
    return { ...INITIAL_STATE, ...state, save_area_errors: action.data }
  case 'GET_NEXT_10_DAYS_INITIAL_CLEANING_DATA_SUCESSFULLY':
    return { ...INITIAL_STATE, ...state, next_10_days_initial_cleaning_data: action.data }
  case 'GET_NEXT_10_DAYS_INITIAL_CLEANING_DATA_FAILED':
    return { ...INITIAL_STATE, ...state, errors: action.data }
  case 'UPDATE_FILED_CLEAN_SUCESSFULLY': {
    let { next_10_days_initial_cleaning_data } = state;
    let { data } = action;
    let updated_next_10_days_initial_cleaning_data = {
      ...next_10_days_initial_cleaning_data,
      results: next_10_days_initial_cleaning_data.results.map((item) => {
        if (item.uuid === data.uuid) {
          return data;
        }
        return item;
      })
    }
    return { ...INITIAL_STATE, ...state, field_cleaning_update_response: action.data, next_10_days_initial_cleaning_data: updated_next_10_days_initial_cleaning_data }
  }
  case 'UPDATE_FILED_CLEAN_FAILED':
    return { ...INITIAL_STATE, ...state, field_cleaning_update_error: action.data }
  case 'CLEAR_ERROR':
    return { ...INITIAL_STATE, ...state, [action.data]: null}
  default:
    return { ...state }
  }
};

export default initialCleaning;